import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.code}>403</h1>
        <h2 style={styles.message}>Unauthorized Access</h2>
        <p style={styles.description}>
          You do not have permission to view this page.
        </p>
        <button style={styles.button} onClick={() => navigate("/")}>
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f9f9f9",
  },
  card: {
    padding: "40px",
    textAlign: "center",
    borderRadius: "8px",
    background: "#fff",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
  },
  code: {
    fontSize: "72px",
    margin: "0",
    color: "#FF5A5F",
  },
  message: {
    fontSize: "28px",
    margin: "10px 0",
    color: "#333",
  },
  description: {
    fontSize: "16px",
    color: "#777",
    marginBottom: "20px",
  },
  button: {
    padding: "10px 20px",
    background: "#2C5282",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};

export default Unauthorized;
